import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import PBNewsSider from './pbNewsSider';
import PBNews from './pbNews';

class PitAndBook extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { pbNewsSiderData, pbNewsData },
        } = this.props;

        return (
            <div className={styles.box}>
                <PBNewsSider content={pbNewsSiderData} />
                <PBNews content={pbNewsData} />
            </div>
        );
    }
}

export default errorBoundary(PitAndBook);
